import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import styled, { css } from 'styled-components';
export const PhoneNumberFieldWrapper = styled.div `
  position: relative;
  ${({ required }) => required &&
    css `
      &:before {
        content: '*';
        position: absolute;
        top: -2px;
        right: 16px;
        color: #ff4016;
        height: 12px;
        font-size: 18px;
        line-height: 12px;
        z-index: 4;
      }
    `}
`;
export const PhoneNumberInput = styled(PhoneInput) `
  .form-control {
    position: relative;
    font-size: 14px;
    letter-spacing: 0.01rem;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding-left: 68px;
    margin-left: 0;
    background: hsla(0, 0%, 0%, 0.07);
    border: none;
    border-radius: 15px;
    line-height: calc(14px + 4px);
    height: 40px;
    width: 100%;
    outline: none;
    color: hsla(0, 0%, 33.33%, 1) !important;
    border-color: transparent;
  }

  &.error {
    .form-control {
      background: #fff2f0;
      box-shadow: inset 0 0 0 2px hsla(2, 77%, 64%, 1) !important;
      color: #ff4d4f;
    }
  }
  .flag-dropdown,
  .flag-dropdown.open {
    background-color: hsla(0, 0%, 0%, 0.07);
    color: hsla(0, 0%, 33.33%, 1);
    vertical-align: middle;
    border: none;
    border-radius: 15px;
    padding: 2px;
    max-width: 100%;
  }
  .flag-dropdown.open {
    .selected-flag {
      background-color: hsla(0, 0%, 100%, 1);
      border-radius: calc(15px - 2px);
    }
  }
  .selected-flag {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    box-sizing: border-box;
    white-space: nowrap;
    font-family: var(--ue-font-family, '"SF UI Text", Roboto, Arial, sans-serif, -apple-system, BlinkMacSystemFont');
    font-size: 14px;
    line-height: calc(14px + 4px);
    gap: calc(5 * 1px);
    padding: calc(calc(calc(5 * 1px) * 2) - 2px) calc(calc(calc(5 * 1px) * 3) - 2px);
    min-height: calc(calc(14px + 4px) + calc(calc(calc(5 * 1px) * 2) - 2px) * 2);
    border-radius: calc(15px - 2px);
    box-shadow: 0 1px 3px 0 #00000012;
    outline: none;
    position: relative;
    width: 48px;
    height: 100%;
    background-color: hsla(0, 0%, 100%, 1);
    padding: calc(calc(calc(5 * 1px) * 2) - 2px) 2px;
    min-width: calc(calc(14px + 4px) + calc(calc(calc(5 * 1px) * 2) - 2px) * 2);
  }

  .country-list {
    outline: none;
    z-index: 1;
    list-style: none;
    position: absolute;
    padding: 0;
    width: 300px;
    max-height: 200px;
    overflow: hidden;
    overflow-y: scroll;
    background-color: hsla(0, 0%, 100%, 1);
    background: hsla(0, 0%, 100%, 1);
    border-radius: calc(12px * 4 / 3);
    box-shadow: 0 8px 10px -6px hsla(0, 0%, 0%, 0.1), 0 15px 35px -5px hsla(0, 0%, 0%, 0.1),
      0 0 0 1px hsla(0, 0%, 0%, 0.07), 0 0 0 1px hsla(0, 0%, 0%, 0.07);
    margin: calc(5 * 1px) 0;

    padding: calc(calc(5 * 1px) * 2) calc(calc(5 * 1px) * 2);
    scrollbar-width: none;

    li {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      position: relative;
      cursor: pointer;
      outline: none;
      border: none;
      background-color: inherit;
      box-sizing: border-box;
      padding: calc(calc(calc(5 * 1px) * 2) - 2px) calc(calc(5 * 1px) * 2);
      border-radius: calc(15px * 2 / 3);
      color: hsla(0, 0%, 33.33%, 1);
      font-size: 14px;
      line-height: calc(14px + 6px);

      color: hsla(0, 0%, 33.33%, 1);
      font-size: 14px;
      line-height: calc(14px + 6px);
      white-space: nowrap;

      .flag {
        display: flex;
        align-items: center;
        position: relative;
        justify-content: center;
        margin-right: 20px;
        padding: calc(calc(5 * 1px) - 2px);
        background-repeat: no-repeat;
      }

      .country-name {
        color: hsla(0, 0%, var(--ue-default-font-color_l, 23.77%), 1);
        font-size: 14px;
        font-size: 14px;
        line-height: calc(14px + 6px);
        font-weight: 500;
      }
      .dial-code {
        color: hsla(0, 0%, 33.33%, 1);
        line-height: calc(14px + 6px);
        font-size: 14px;
      }
    }
  }
`;
export const ErrorMessage = styled.div `
  position: absolute;
  min-width: calc(calc(calc(5 * 1px) * 3) * 2 + 47px);
  bottom: calc(100% + calc(5 * 1px) - 2px);
  z-index: 15;
  opacity: 0;
  transform: scale(0);

  ${PhoneNumberFieldWrapper}:hover & {
    ${({ error }) => error &&
    css `
        animation: ca-error-show 0.15s cubic-bezier(0, 0, 0.2, 1) forwards;
      `};
  }

  span {
    background-color: hsla(2, 77%, calc(64% - 3%), 1);
    ${({ error }) => error &&
    css `
        padding: calc(calc(var(--ue-spacing-step-px, 1) * 1px) + 2px) calc(calc(5 * 1px) * 2);
      `};
    border-radius: 15px;
    min-width: calc(calc(calc(5 * 1px) * 3) * 2 + 47px);
    text-align: center;
    box-sizing: border-box;
    font-size: calc(14px - 2px);
    line-height: 14px;
    color: hsla(
      var(--ue-secondary-font-color_h, 0),
      var(--ue-secondary-font-color_s, 0%),
      var(--ue-secondary-font-color_l, 100%),
      var(--ue-secondary-font-color_t, 1)
    );
  }

  @keyframes ca-error-show {
    0% {
      opacity: 0;
      transform: scale(0);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
`;
const CustomPhoneInput = ({ field, form, value, required, placeholder = 'Phone Number', ...props }) => {
    const error = form.errors[field.name] && form.touched[field.name];
    return (_jsxs(PhoneNumberFieldWrapper, { required: true, children: [_jsx(PhoneNumberInput, { ...field, ...props, country: 'us', value: field.value, onChange: (value) => form.setFieldValue(field.name, value), onBlur: () => form.setFieldTouched(field.name, true), placeholder: placeholder, containerClass: error ? 'error' : '' }), _jsx(ErrorMessage, { error: !!error, children: _jsx("span", { children: form.errors[field.name] }) })] }));
};
export default CustomPhoneInput;
